/* Sienna cart drawer – replaces UpCart features
   Timer, tiered rewards bar, upsells, recommendations, savings row,
   "Cart • N" title and "Checkout • total" button.
   Settings: Theme editor > Header > Košík – nastavení              */
(function () {
  'use strict';
  var CFG = window.SoCart || {};
  ['timer', 'rewards', 'upsells', 'recs'].forEach(function (k) { CFG[k] = CFG[k] || {}; });
  CFG.strings = CFG.strings || {};
  CFG.strings.add = CFG.strings.add || 'Add';
  CFG.strings.adding = CFG.strings.adding || '…';
  var ROOT = (CFG.root || '/').replace(/\/?$/, '/');
  var cart = null;
  var renderTimer = null;
  var recsCache = {};
  var busy = false;

  /* ---------- helpers ---------- */
  function drawer() { return document.getElementById('CartDrawer'); }
  function q(sel, root) { return (root || document).querySelector(sel); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function toCents(v) {
    if (v == null || v === '') return 0;
    if (typeof v === 'string' && v.indexOf('.') > -1) return Math.round(parseFloat(v) * 100);
    return parseInt(v, 10) || 0;
  }
  function money(cents) {
    var fmt = (window.theme && theme.settings && theme.settings.moneyFormat) || '${{amount}}';
    cents = Math.round(Number(cents) || 0);
    function group(n, dec, th, ds) {
      var fixed = (n / 100).toFixed(dec);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts[1] ? parts[0] + ds + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return group(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return group(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(cents, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return group(cents, 2, "'", '.');
        default: return group(cents, 2, ',', '.');
      }
    });
  }
  function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }
  function setHTML(el, html) { if (el && el.__soHtml !== html) { el.innerHTML = html; el.__soHtml = html; } }
  function show(el, on) { if (el) { if (on) el.removeAttribute('hidden'); else el.setAttribute('hidden', ''); } }
  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200);
  }

  /* ---------- data ---------- */
  function fetchCart() {
    return fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return c; });
  }

  function scheduleRender(delay) {
    clearTimeout(renderTimer);
    renderTimer = setTimeout(function () { fetchCart().then(render).catch(function () {}); }, delay == null ? 250 : delay);
  }

  /* ---------- header + checkout + savings ---------- */
  function renderBasics(d) {
    var n = cart.item_count;
    setText(q('.drawer__title', d), (CFG.titleLabel || 'Cart') + (n > 0 ? ' • ' + n : ''));
    var btn = q('.so-checkout', d);
    if (btn) setText(btn, (CFG.checkoutLabel || 'Checkout') + (n > 0 ? ' • ' + money(cart.total_price) : ''));

    var row = q('.so-discount-row', d);
    if (row) {
      var disc = cart.total_discount || 0;
      setText(q('.so-discount-row__value', row), '−' + money(disc));
      show(row, disc > 0);
    }
    // benefits + payment icons from the settings section
    var extra = q('.so-footer-extra', d);
    var tpl = document.getElementById('so-cart-footer-tpl');
    if (extra && tpl && !extra.childElementCount) extra.appendChild(tpl.content.cloneNode(true));
    // header bubble
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', n > 0);
    });
  }

  /* ---------- timer ---------- */
  var TIMER_KEY = 'so_cart_timer_end';
  var timerInt = null;
  function timerEnd() {
    var end = 0;
    try { end = parseInt(localStorage.getItem(TIMER_KEY), 10) || 0; } catch (e) {}
    if (!end || end < Date.now()) {
      end = Date.now() + (CFG.timer.minutes || 20) * 60000;
      try { localStorage.setItem(TIMER_KEY, String(end)); } catch (e) {}
    }
    return end;
  }
  function renderTimerBar(d) {
    var el = q('.so-timer', d);
    if (!el) return;
    if (!CFG.timer || !CFG.timer.enabled || !cart.item_count) { show(el, false); return; }
    show(el, true);
    function tick() {
      var left = Math.max(0, timerEnd() - Date.now());
      var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
      var t = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
      setHTML(el, esc(CFG.timer.text).replace('{TIMER}', '<b>' + t + '</b>'));
    }
    tick();
    if (!timerInt) timerInt = setInterval(function () { if (cart && cart.item_count) tick(); }, 1000);
  }

  /* ---------- tiered rewards ---------- */
  function renderRewards(d) {
    var el = q('.so-rewards', d);
    var R = CFG.rewards || {};
    var tiers = (R.tiers || []).filter(function (t) { return t && t.count > 0; }).sort(function (a, b) { return a.count - b.count; });
    if (!el) return;
    if (!R.enabled || !tiers.length || !cart.item_count) { show(el, false); return; }
    var n = cart.item_count;
    var max = tiers[tiers.length - 1].count;
    var next = null;
    for (var i = 0; i < tiers.length; i++) { if (n < tiers[i].count) { next = tiers[i]; break; } }
    var msg;
    if (next) {
      var need = next.count - n;
      msg = esc(R.text)
        .replace('{COUNT}', '<b>' + need + '</b>')
        .replace('{ITEMS}', need === 1 ? 'item' : 'items')
        .replace('{REWARD}', '<strong>' + esc(next.label) + '</strong>');
    } else {
      msg = esc(R.done);
    }
    var pct = Math.min(100, (n / max) * 100);
    var marks = tiers.map(function (t) {
      var on = n >= t.count;
      var short = (String(t.label).match(/\d+\s*%/) || [t.label])[0];
      return '<div class="so-rewards__mark' + (on ? ' is-on' : '') + '" style="left:' + (t.count / max * 100) + '%">' +
        '<span class="so-rewards__dot">' + (on
          ? '<svg viewBox="0 0 24 24"><path d="M5 12.5l4.2 4.2L19 7"/></svg>'
          : '<svg viewBox="0 0 24 24"><path d="M4 11h16v10H4zM12 11v10M3 7h18v4H3zM12 7c-1.5-3-5-3.5-5-1.2C7 7 9.5 7 12 7zm0 0c1.5-3 5-3.5 5-1.2C17 7 14.5 7 12 7z"/></svg>') +
        '</span><span class="so-rewards__label">' + esc(short) + '</span></div>';
    }).join('');
    setHTML(el,
      '<div class="so-rewards__msg">' + msg + '</div>' +
      '<div class="so-rewards__track"><div class="so-rewards__fill" style="width:' + pct + '%"></div>' + marks + '</div>');
    show(el, true);
  }

  /* ---------- product tiles (upsells + recs) ---------- */
  function tile(p, layout) {
    var variants = (p.variants || []).filter(function (v) { return v.available; });
    if (!variants.length) return '';
    var v = variants[0];
    var image = p.image || p.featured_image || '';
    var price = toCents(v.price), cmp = toCents(v.compare_at_price);
    var priceHtml = (cmp > price ? '<s>' + money(cmp) + '</s> ' : '') + '<span class="so-tile__now">' + money(price) + '</span>';
    var select = '';
    if (variants.length > 1) {
      select = '<select class="so-tile__select" aria-label="Variant">' + variants.map(function (x) {
        return '<option value="' + x.id + '" data-price="' + toCents(x.price) + '" data-cmp="' + toCents(x.compare_at_price) + '">' + esc(x.title) + '</option>';
      }).join('') + '</select>';
    }
    return '<div class="so-tile so-tile--' + layout + '" data-variant="' + v.id + '">' +
      '<a class="so-tile__img" href="' + esc(p.url) + '">' + (image ? '<img src="' + esc(imgUrl(image, 240)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>' +
      '<div class="so-tile__body">' +
        '<a class="so-tile__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
        '<div class="so-tile__price">' + priceHtml + '</div>' +
        select +
      '</div>' +
      '<button type="button" class="so-tile__add">' + esc(CFG.strings.add) + '</button>' +
    '</div>';
  }

  function inCartIds() { return cart.items.map(function (i) { return i.product_id; }); }

  function renderUpsells(d) {
    var el = q('.so-upsells', d);
    var U = CFG.upsells || {};
    if (!el) return [];
    if (!U.enabled || !cart.item_count) { show(el, false); return []; }
    var ids = inCartIds();
    var seen = {}, list = [];
    (U.rules || []).forEach(function (r) {
      var hit = r.any || (r.trigger || []).some(function (id) { return ids.indexOf(id) > -1; });
      if (!hit) return;
      (r.products || []).forEach(function (p) {
        if (seen[p.id] || ids.indexOf(p.id) > -1) return;
        seen[p.id] = 1; list.push(p);
      });
    });
    list = list.slice(0, 10);
    var html = list.map(function (p) { return tile(p, 'h'); }).join('');
    if (!html) { show(el, false); return []; }
    setHTML(el, '<div class="so-block-title">' + esc(U.title) + '</div><div class="so-upsells__row">' + html + '</div>');
    show(el, true);
    return list.map(function (p) { return p.id; });
  }

  function renderRecs(d, exclude) {
    var el = q('.so-recs', d);
    var R = CFG.recs || {};
    if (!el) return;
    if (!R.enabled || !cart.item_count) { show(el, false); return; }
    var src = cart.items[0].product_id;
    var ids = inCartIds().concat(exclude || []);
    var done = function (products) {
      var list = (products || []).filter(function (p) { return ids.indexOf(p.id) === -1; }).slice(0, R.count || 3);
      var html = list.map(function (p) { return tile(p, 'v'); }).join('');
      if (!html) { show(el, false); return; }
      setHTML(el, '<div class="so-block-title">' + esc(R.title) + '</div><div class="so-recs__list">' + html + '</div>');
      show(el, true);
    };
    if (recsCache[src]) { done(recsCache[src]); return; }
    fetch(ROOT + 'recommendations/products.json?product_id=' + src + '&limit=10&intent=related', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) { recsCache[src] = j.products || []; if (cart && cart.items.length && cart.items[0].product_id === src) done(recsCache[src]); })
      .catch(function () { show(el, false); });
  }

  /* ---------- render all ---------- */
  function render() {
    var d = drawer();
    if (!d || !cart) return;
    renderBasics(d);
    renderTimerBar(d);
    renderRewards(d);
    var shownUpsells = renderUpsells(d);
    renderRecs(d, shownUpsells);
  }

  /* ---------- add from tile ---------- */
  function addVariant(id, btn) {
    if (busy) return;
    busy = true;
    var label = btn.textContent;
    btn.textContent = CFG.strings.adding; btn.disabled = true;
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        var item = res && res.items ? res.items[0] : res;
        // ask the theme to rebuild its drawer items
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: item } }));
        document.dispatchEvent(new CustomEvent('cart:build'));
        scheduleRender(400);
      })
      .catch(function () {})
      .then(function () { busy = false; btn.textContent = label; btn.disabled = false; });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.so-tile__add');
    if (!b) return;
    e.preventDefault();
    var t = b.closest('.so-tile');
    var sel = q('.so-tile__select', t);
    addVariant(sel ? sel.value : t.getAttribute('data-variant'), b);
  });

  document.addEventListener('change', function (e) {
    var s = e.target;
    if (!s.classList || !s.classList.contains('so-tile__select')) return;
    var o = s.options[s.selectedIndex];
    var price = +o.getAttribute('data-price'), cmp = +o.getAttribute('data-cmp');
    var box = q('.so-tile__price', s.closest('.so-tile'));
    if (box) box.innerHTML = (cmp > price ? '<s>' + money(cmp) + '</s> ' : '') + '<span class="so-tile__now">' + money(price) + '</span>';
  });

  /* ---------- listen to every cart change ---------- */
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?/;
  if (window.fetch) {
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = _fetch.apply(this, arguments);
      if (CART_RE.test(url)) p.then(function () { scheduleRender(); }).catch(function () {});
      return p;
    };
  }
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (CART_RE.test(String(url))) this.addEventListener('loadend', function () { scheduleRender(); });
    return _open.apply(this, arguments);
  };

  function observe() {
    var d = drawer();
    if (!d) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.nodeType !== 1) t = t.parentNode;
        if (t && t.closest && t.closest('.so-own')) continue;
        if (muts[i].type === 'attributes' && muts[i].attributeName !== 'class') continue;
        if (t && t.closest && (t.closest('.drawer__title') || t.closest('.so-checkout'))) continue;
        scheduleRender(150);
        return;
      }
    }).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  ['cart:updated', 'cart:open', 'ajaxProduct:added'].forEach(function (ev) {
    document.addEventListener(ev, function () { scheduleRender(300); });
  });

  function init() { observe(); scheduleRender(0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
